// Importo i reducers modulari
import { documentBaseReducer, 
  processedNotesReducer, 
  loadingStateReducer, 
  feedbackReducer, 
  folderReducer 
} from './document';

 const initialState = {
  documents: [],
  extractedQA: [],
  flashcardsQA: [],
  quizQA: [],
  isSubmitting: false,
  isProcessing: false,
  isGenerate: false,
  isLoading: false,
  isGenerating: false,
  generationError: null,
  loadingMessage: null,
  loadingProgress: null,
  extractionMetadata: null, // Metadata sull'estrazione del testo (pagine, metodo, tempo)
  documentsQA: [],
  tags: [],
  summary: '',
  processedNotes: [],
  feedbacks: { // Nuovo stato per i feedback unificati
    questions: new Map(),
    flashcards: new Map()
  },
  // Nuovo campo per le cartelle
  folders: [],
  // Collegamenti documento -> cartella agganciati dal client e non ancora
  // confermati da Firebase: proteggono l'aggancio dalla lettura successiva
  // (vedi folderReducer.applyPendingLinks). Vivono solo per la sessione.
  pendingFolderLinks: {},
  // Documento selezionato
  selectedDocument: null,
  // Contatore per forzare aggiornamenti UI
  folderRefreshCounter: 0,
  // Documento generato più recente
  generatedDocument: null,
  hasPreview: false, // Nuovo stato per gestire la presenza di una preview
  customInstructions: '', // Nuovo stato per le istruzioni personalizzate
  // ACCESO di default (CEO, 28/08): la funzionalita' si deve vedere e usare,
  // e chi non la vuole la spegne. Regge perche' il costo per caricamento e'
  // bloccato — si genera il piano e SOLO il primo episodio da 5 minuti.
  autoPodcast: true,
  selectedMateria: '', // Materia selezionata per upload Maturità
  showMateriaWarning: false, // Mostra avviso quando manca la materia
  studyMode: null, // Modalità di studio: null (non selezionata), 'study' o 'review'
  examDate: '', // Data dell'esame
  excludedDays: [], // Giorni della settimana esclusi dal piano (0=Dom, 1=Lun, ..., 6=Sab)
  studyDateWarning: false, // Mostra avviso quando manca la data con piano selezionato
  folderTitle: '', // Titolo cartella per upload multipli
  targetFolderId: null, // Cartella ESISTENTE di destinazione (Home V2; v1 non la usa)
  // Stato avanzamento elaborazione documento (Firestore onSnapshot)
  docProcessingStatus: null,   // 'extracting' | 'chunking' | 'generating_qa' | 'generating_flashcards' | 'done' | 'error'
  docProcessingError: null,    // messaggio d'errore leggibile, presente solo su 'error'
  docProcessingDocId: null,    // doc_id monitorato dal listener
};
 
 
 // Funzione di validazione per verificare che un payload sia presente e valido
 const validatePayload = (payload, actionType) => {
  if (!payload) {
    console.error(`Payload mancante per l'azione ${actionType}`);
    return false;
  }
  
  if (typeof payload !== 'object') {
    console.error(`Payload non valido per l'azione ${actionType}. Atteso un oggetto, ricevuto: ${typeof payload}`);
    return false;
  }
  
  return true;
 };
 
 // Funzione di validazione per verificare che un ID sia presente e valido
 const validateId = (id, entityName) => {
  if (!id) {
    console.error(`ID ${entityName} non valido o mancante`);
    return false;
  }
  
  if (typeof id !== 'string') {
    console.error(`ID ${entityName} deve essere una stringa, ricevuto: ${typeof id}`);
    return false;
  }
  
  return true;
 };
 
 const documentReducer = (state = initialState, action) => {
  // Validazione di base dell'azione
  if (!action || !action.type) {
    console.error('Azione non valida passata al reducer documentReducer');
    return state;
  }
  
  // Prova a utilizzare i reducers modulari
  // 1. Prova il documentBaseReducer
  const baseResult = documentBaseReducer(state, action);
  if (baseResult !== null) {
    return baseResult;
  }
  
  // 2. Prova il processedNotesReducer
  const notesResult = processedNotesReducer(state, action);
  if (notesResult !== null) {
    return notesResult;
  }
  
  // 3. Prova il loadingStateReducer
  const loadingResult = loadingStateReducer(state, action);
  if (loadingResult !== null) {
    return loadingResult;
  }
  
  // 4. Prova il feedbackReducer
  const feedbackResult = feedbackReducer(state, action);
  if (feedbackResult !== null) {
    return feedbackResult;
  }
  
  // 5. Prova il folderReducer
  const folderResult = folderReducer(state, action);
  if (folderResult !== null) {
    return folderResult;
  }
  
  switch (action.type) {
    default:
      return state;
  }
 };
 
 
 export default documentReducer;